export default function memoize(fn){var cache={};return function(arg){if(cache[arg]===undefined){cache[arg]=fn(arg);}return cache[arg];};}